export const aboutData = {
    title: "Über mich",
    description1: "Ich bin Full-Stack-Entwicklerin und wohne in Deutschland.",
    description2: "Kürzlich habe ich einen Full-Stack Bootcamp-Kurs für Web- und App-Entwicklung bei WBS Coding School, Berlin abgeschlossen. Es war ein projektbasierter Vollzeit-Online-Kurs.",
    description3: "Zuvor sammelte ich auch praktische Erfahrungen als Senior SEO Executive bei LogiTech Solution, Surat und als Digital Marketing Manager bei Glam Elegance, Surat, Indien.",

    image: 2,
};
